import { ReactNodeViewRenderer } from "@tiptap/react";
import { CustomMentionExtensionConfig } from "./extention-config";
import type { MentionExtensionOptions } from "./extention-config";
import type { MentionHandler } from "./types";
import type { MentionNodeViewProps } from "./mention-node-view";
import { MentionNodeView } from "./mention-node-view";
import { renderMentionsDropdown } from "./utils";

export const CustomMentionExtension = (props: MentionHandler) => {
  const { getMentionedEntityDetails, renderComponent, searchCallback } = props;
  return CustomMentionExtensionConfig.extend({
    addOptions(this: { parent?: () => Partial<MentionExtensionOptions> }) {
      return {
        ...this.parent?.(),
        renderComponent,
        getMentionedEntityDetails
      };
    },

    addNodeView() {
      return ReactNodeViewRenderer((reactNodeViewProps) => (
        <MentionNodeView
          {...reactNodeViewProps}
          node={reactNodeViewProps.node as MentionNodeViewProps["node"]}
        />
      ));
    }
  }).configure({
    suggestion: {
      render: renderMentionsDropdown({
        searchCallback
      })
    }
  });
};
